import { ReactElement, useContext, useEffect, useState } from 'react'
import { UserContext } from '../../../context/UserContext'
import UserAction from '../../../context/action/UserAction'
import { TableUI } from '../../../../../common/ui/table/TableUI'
import { getPaymentsTable } from '../../../model/PaymentsUI'
import DevelopusTable from '../../../../../common/ui/table/DevelopusTable'
import { t } from 'i18next'
import DevelopusButton from '../../../../../common/ui/button/DevelopusButton'
import { AddOutlined } from '@mui/icons-material'
import DevelopusDialog from '../../../../../common/ui/dialog/DevelopusDialog'
import CreateDebt from './CreateDebt'
import CreatePayment from './CreatePayment'
import DevelopusSnackbarContext from '../../../../../common/ui/snackbar/DevelopusSnackbarContext'
import DevelopusSnackbarActions from '../../../../../common/ui/snackbar/DevelopusSnackbarActions'
import { getDebtsTable } from '../../../model/DebtsUI'
import { UUID } from 'crypto'

const PaymentTransactionsView = (): ReactElement => {
  const snackbarContext = useContext(DevelopusSnackbarContext)
  const snackbarActions = new DevelopusSnackbarActions(snackbarContext)

  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [debtDialog, setDebtDialog] = useState<boolean>(false)
  const [paymentDialog, setPaymentDialog] = useState<boolean>(false)

  const [debtsTable, setDebtsTable] = useState<TableUI | undefined>(undefined)
  const [paymentsTable, setPaymentsTable] = useState<TableUI | undefined>(
    undefined,
  )

  useEffect(() => {
    const student = action.getCurrentStudent()

    if (student !== undefined) {
      const { debts, payments } = student
        .getTransactions()
        .toPaymentTransactionsUI()

      setDebtsTable(getDebtsTable(debts))
      setPaymentsTable(getPaymentsTable(payments))
    }
  }, [action.getCurrentStudent()])

  const handleAddDebt = () => {
    setDebtDialog(true)
  }

  const handleAddPayment = () => {
    setPaymentDialog(true)
  }

  const saveDebt = () => {
    action.createNewDebt()
    setDebtDialog(false)

    snackbarActions.showSnackbar(`Debt created`)
  }

  const editDebt = (id: UUID) => {
    console.log('edit debt')
    console.log(id)
  }

  const removeDebt = (id: UUID) => {
    action.removeDebt(id)
    snackbarActions.showSnackbar(`Debt removed`)
  }

  const savePayment = () => {
    action.createNewPayment()
    setPaymentDialog(false)

    snackbarActions.showSnackbar(`Payment created`)
  }

  const editPayment = (id: UUID) => {
    console.log('edit payment')
    console.log(id)
  }

  const removePayment = (id: UUID) => {
    action.removePayment(id)
    snackbarActions.showSnackbar(`Payment removed`)
  }

  return (
    <>
      {debtsTable !== undefined && (
        <>
          <div style={{ display: 'flex' }}>
            <h2> {t('users.transactions.debts')} </h2>
            <div style={{ padding: '25px 10px' }}>
              (
              <DevelopusButton
                text={t('users.transactions.createDebt')}
                handleClick={handleAddDebt}
                disabled={false}
                icon={<AddOutlined />}
              />
              )
            </div>
          </div>
          <DevelopusTable
            columnsUI={debtsTable.columnsUI}
            rowsUI={debtsTable.rowsUI}
            handleEdit={editDebt}
            handleRemove={removeDebt}
          />
        </>
      )}

      {paymentsTable !== undefined && (
        <>
          <div style={{ display: 'flex' }}>
            <h2> {t('users.transactions.payments')} </h2>
            <div style={{ padding: '25px 10px' }}>
              (
              <DevelopusButton
                text={t('users.transactions.createPayment')}
                handleClick={handleAddPayment}
                disabled={false}
                icon={<AddOutlined />}
              />
              )
            </div>
          </div>
          <DevelopusTable
            columnsUI={paymentsTable.columnsUI}
            rowsUI={paymentsTable.rowsUI}
            handleEdit={editPayment}
            handleRemove={removePayment}
          />
        </>
      )}

      <DevelopusDialog
        title={t('users.transactions.createDebt')}
        open={debtDialog}
        handleSave={saveDebt}
        handleClose={() => setDebtDialog(false)}
        element={<CreateDebt />}
      />

      <DevelopusDialog
        title={t('users.transactions.createPayment')}
        open={paymentDialog}
        handleSave={savePayment}
        handleClose={() => setPaymentDialog(false)}
        element={<CreatePayment />}
      />
    </>
  )
}

export default PaymentTransactionsView
